import React, { useEffect, useMemo, useState } from "react";
import "react-medium-image-zoom/dist/styles.css";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  Row,
  RSelect,
} from "../../components/Component";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";

import { ErrorMessage } from "@hookform/error-message";
import { Controller, FormProvider, useForm } from "react-hook-form";
import { NumericFormat } from "react-number-format";
import { useHistory, useParams } from "react-router";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import ReactSelect from "react-select";
import { toast } from "react-toastify";
import { Input } from "reactstrap";
import { GET, POST, PUT } from "../../helper/api";
import { EMPLOYEE_STATUS, EMPLOYEE_UNIT, USER_ROLES, USER_ROLES_NAME } from "../../utils/Utils";

const EMPLOYEE_STATUS_OPTIONS = Object.keys(EMPLOYEE_STATUS).map((c) => ({
  label: EMPLOYEE_STATUS[c],
  value: c,
}));

const USER_ROLES_OPTIONS = Object.keys(USER_ROLES).map((c) => ({
  label: USER_ROLES_NAME[c],
  value: c,
}));

const EMPLOYEE_UNIT_OPTIONS = Object.keys(EMPLOYEE_UNIT).map((c) => ({
  label: EMPLOYEE_UNIT[c],
  value: c,
}));


const EMPLOYEE_DEFAULT = {
  id: null,
  username: "",
  password: "",
  role: "",
  name: "",
  salaryForInsurance: "",
  salaryForCalculator: "",
  baseSalary: 0,
  status: EMPLOYEE_STATUS_OPTIONS[0].value,
  active: true,
  allowPieceWage: false,
  allowCrane: false,
  insuranceTaxStartAt: null,
  responsibilityAllowance: 0,
  bestEmployeeAllowance: 0,
  positionSalary: 0,
  toxicAllowance: 0,
  annualSalary: 0,
  laborSafetyAllowance: 0,
  travelAllowance: 0,
  telephoneAllowance: 0,
  housingSubsidy: 0,
  productivitySalary: 0,
  attendanceAllowance: 0,
  unit: 'NVVP',
  allowOilRefining: false,
  allowFoodAllowance: false,
  annualYear: 0,
  workingDayToReceivedFullAllowance: null,
  dependents: 0,
};

const AddEmployee = () => {
  const history = useHistory();
  const { search } = useLocation();

  const duplicateId = new URLSearchParams(search).get("duplicateId");

  const params = useParams();
  const id = duplicateId || params.id;

  const methodForm = useForm({
    defaultValues: EMPLOYEE_DEFAULT,
  });
  const { errors, register, handleSubmit, reset, getValues, control, watch, setValue } = methodForm;
  const [employeeTemplates, setEmployeeTemplates] = useState([])
  // Giữ nguyên toàn bộ metadata (JSON) hiện có của user, chỉ chỉnh sửa key telegramUserId
  const [metadata, setMetadata] = useState({});
  const isEdit = id && id !== "create" && !duplicateId;

  useEffect(() => {
    if (id) {
      GET("user/" + id, {}, true).then((resp) => {
        reset(resp.data);
        setMetadata(resp.data?.metadata || {});
      });
    }
    GET(`employee-template`, {}, true)
      .then(({ data: { rows } }) => {
        setEmployeeTemplates(rows.map(row => ({
          label: EMPLOYEE_UNIT[row.unit] || row.unit,
          value: row.unit,
          data: row
        })));
      })
  }, []);

  const onHandleSubmit = () => {
    const {
      username,
      password,
      role,
      name,
      phone,
      salaryForInsurance,
      salaryForCalculator,
      status,
      userId,
      active,
      allowPieceWage,
      baseSalary,
      allowCrane,
      insuranceTaxStartAt,

      responsibilityAllowance,
      bestEmployeeAllowance,
      positionSalary,
      toxicAllowance,
      annualSalary,
      laborSafetyAllowance,
      travelAllowance,
      telephoneAllowance,
      housingSubsidy,
      productivitySalary,
      attendanceAllowance,
      unit,
      allowOilRefining,
      allowFoodAllowance,
      annualYear,
      lastUpdateAnnualYear,
      allowSalary,
      pit,
      foodAllowancePerShift,
      workingDayToReceivedFullAllowance,
      dependents
    } = getValues();

    const formData = {
      username,
      ...(!isEdit ? { password } : {}),
      role,
      name,
      phone,
      salaryForInsurance: salaryForInsurance || null,
      salaryForCalculator: salaryForCalculator || null,
      status,
      userId,
      active,
      allowPieceWage,
      baseSalary,
      allowCrane,
      insuranceTaxStartAt: insuranceTaxStartAt || null,

      responsibilityAllowance,
      bestEmployeeAllowance,
      positionSalary,
      toxicAllowance,
      annualSalary,
      laborSafetyAllowance,
      travelAllowance,
      telephoneAllowance,
      housingSubsidy,
      productivitySalary,
      attendanceAllowance,
      unit,
      allowOilRefining,
      allowFoodAllowance,
      annualYear,
      lastUpdateAnnualYear,
      allowSalary,
      pit,
      foodAllowancePerShift: foodAllowancePerShift ?? null,
      workingDayToReceivedFullAllowance: workingDayToReceivedFullAllowance ?? null,
      dependents: dependents ?? null,
      // Gửi lại nguyên metadata cũ + key telegramUserId đã cập nhật (không đè toàn bộ JSON)
      metadata,
    };

    const request = isEdit ? PUT(`user/${id}`, formData, {}, true) : POST("user", { ...formData }, {}, true);

    request
      .then((res) => {
        if (isEdit) {
          toast.success("Cập nhật thành công");
        } else {
          toast.success("Thêm thành công");
        }
        back();
      })
      .catch(({ response }) => {
        toast.error(response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại.");
      })
      .finally(() => { });
  };

  const back = () => {
    return history.goBack();
  };

  const unit = watch('unit')

  const isExtendSalaryForInsurance = useMemo(() => {
    return ['MECHANICAL', 'CN'].includes(unit)
  }, [unit])
  const calculateSalaryForInsurance = ({
    unit,
    baseSalary = 0,
    responsibilityAllowance = 0,
    bestEmployeeAllowance = 0,
    positionSalary = 0,
    toxicAllowance = 0,
    annualSalary = 0,
  }) => {
    let salaryForCalculator = +baseSalary + +responsibilityAllowance + +annualSalary;
    if (['MECHANICAL', 'CN'].includes(unit)) {
      salaryForCalculator += +bestEmployeeAllowance + +positionSalary + +toxicAllowance
    } else {
      setValue('bestEmployeeAllowance', 0);
      setValue('positionSalary', 0);
      setValue('toxicAllowance', 0);
    }
    setValue('salaryForCalculator', salaryForCalculator);
  }

  const onSelectEmployeeTemplate = ({
    baseSalary,
    responsibilityAllowance,
    positionSalary,
    toxicAllowance,
    attendanceAllowance,
    laborSafetyAllowance,
    travelAllowance,
    telephoneAllowance,
    housingSubsidy,
    unit,
  }) => {
    reset({
      ...getValues(),
      baseSalary,
      responsibilityAllowance,
      positionSalary,
      toxicAllowance,
      attendanceAllowance,
      laborSafetyAllowance,
      travelAllowance,
      telephoneAllowance,
      housingSubsidy,
      unit,
    })
  }
  return (
    <React.Fragment>
      <Head title="Thêm/sửa nhân viên"></Head>

      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>{(!isEdit ? "Thêm" : "Sửa") + " nhân viên"}</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div className="toggle-expand-content">
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li>
                      <div>
                        <Button className="toggle d-none d-md-inline-flex" color="primary" onClick={() => back()}>
                          <span>Trở về</span>
                        </Button>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <div id="DataTables_Table_1_wrapper" className="dataTables_wrapper dt-bootstrap4 no-footer">
                <div className="row justify-between g-2">
                  <div className="col-8 col-sm-6 text-start"></div>
                  <div className="col-5 col-sm-6 text-end">
                    <div className="datatable-filter">
                      <div className="d-flex justify-content-end g-2">
                        <div className="dataTables_length" id="DataTables_Table_1_length"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="my-3">
                  <FormProvider {...methodForm}>
                    <form onSubmit={handleSubmit(onHandleSubmit)}>
                      <div className="mt-4">
                        <Row className="g-2">
                          <Col size="12">
                            <h4>Liên kết tài khoản đăng nhập</h4>
                          </Col>

                          <Col size="6">
                            <div className="form-group">
                              <label className="form-label" >
                                Tên đăng nhập <span className="text-danger">*</span>
                              </label>
                              <div className="form-control-wrap">
                                <input
                                  className="form-control"
                                  type="text"
                                  name="username"
                                  ref={register({
                                    required: "Vui lòng nhập thông tin",
                                  })}
                                />
                                <ErrorMessage errors={errors} name="username" render={({ message }) => <span className="invalid">{message}</span>} />
                              </div>
                            </div>
                          </Col>
                          {!isEdit ? (
                            <Col size="6">
                              <div className="form-group">
                                <label className="form-label" >
                                  Mật khẩu <span className="text-danger">*</span>
                                </label>
                                <div className="form-control-wrap">
                                  <input
                                    className="form-control"
                                    type="password"
                                    name="password"
                                    ref={register({
                                      required: "Vui lòng nhập thông tin",
                                    })}
                                  />
                                  <ErrorMessage errors={errors} name="password" render={({ message }) => <span className="invalid">{message}</span>} />
                                </div>
                              </div>
                            </Col>
                          ) : (
                            <></>
                          )}
                          <Col size="6">
                            <div className="form-group">
                              <label className="form-label" >
                                Vai trò <span className="text-danger">*</span>
                              </label>
                              <div className="form-control-wrap">
                                <Controller
                                  control={control}
                                  name="role"
                                  rules={{
                                    required: "Vui lòng nhập thông tin",
                                  }}
                                  render={({ onChange, value, name, ref }) => (
                                    <RSelect
                                      inputRef={ref}
                                      name={name}
                                      options={USER_ROLES_OPTIONS}
                                      value={USER_ROLES_OPTIONS.find((c) => c.value === value)}
                                      onChange={(val) => onChange(val.value)}
                                    />
                                  )}
                                />
                                <ErrorMessage errors={errors} name="role" render={({ message }) => <span className="invalid">{message}</span>} />
                              </div>
                            </div>
                          </Col>


                          <Col size="6">
                            <div className="form-group">
                              <label className="form-label" >
                                Họ và tên <span className="text-danger">*</span>
                              </label>
                              <div className="form-control-wrap">
                                <input
                                  className="form-control"
                                  type="text"
                                  name="name"
                                  ref={register({
                                    required: "Vui lòng nhập thông tin",
                                  })}
                                />
                                <ErrorMessage errors={errors} name="name" render={({ message }) => <span className="invalid">{message}</span>} />
                              </div>
                            </div>
                          </Col>
                          <Col size="6">
                            <div className="form-group">
                              <label className="form-label" >
                                Chọn dữ liệu lương theo mẫu
                              </label>
                              <div className="form-control-wrap">
                                <RSelect
                                  options={employeeTemplates}

                                  onChange={(val) => {
                                    if (val?.value) {
                                      onSelectEmployeeTemplate(val.data)
                                    }
                                  }} />

                              </div>
                            </div>
                          </Col>

                          <Col size="6">
                            <div className="form-group">
                              <label className="form-label" >
                                Telegram User ID
                              </label>
                              <div className="form-control-wrap">
                                <input
                                  className="form-control"
                                  type="text"
                                  inputMode="numeric"
                                  placeholder="VD: 8763422043"
                                  value={metadata.telegramUserId ?? ""}
                                  onChange={(e) => {
                                    const raw = e.target.value.trim();
                                    setMetadata((prev) => {
                                      const next = { ...prev };
                                      if (raw === "") {
                                        delete next.telegramUserId;
                                      } else {
                                        next.telegramUserId = /^\d+$/.test(raw) ? Number(raw) : raw;
                                      }
                                      return next;
                                    });
                                  }}
                                />
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </div>
                      <div className="mt-4">
                        <Row className="g-2">
                          <Col size="12">
                            <h4>Khoản lương  để tính bảo hiểm</h4>
                          </Col>
                          <Col size="6">
                            <div className="form-group">
                              <label className="form-label" >
                                Khối nhân viên(đ)
                              </label>
                              <div className="form-control-wrap">
                                <Controller
                                  control={control}
                                  name="unit"
                                  render={({ onChange, value, ref, name }) => (
                                    <RSelect
                                      inputRef={ref}
                                      options={EMPLOYEE_UNIT_OPTIONS}
                                      value={EMPLOYEE_UNIT_OPTIONS.find((c) => c.value === value)}
                                      onChange={(val) => {
                                        onChange(val.value);
                                        calculateSalaryForInsurance({
                                          ...getValues(),
                                          [name]: val.value,
                                        })
                                      }}
                                    />
                                  )}
                                />
                              </div>
                            </div>
                          </Col>

                          <Col size="6">
                            <div className="form-group">
                              <label className="form-label" >
                                Lương cơ bản(đ)
                                <span className="text-danger">*</span>
                              </label>
                              <div className="form-control-wrap">
                                <Controller
                                  control={control}
                                  name="baseSalary"
                                  rules={{ required: "Vui lòng nhập thông tin" }}
                                  render={({ onChange, value, ref, name }) => (
                                    <NumericFormat
                                      className="form-control"
                                      inputRef={ref}
                                      type="text"
                                      value={value}
                                      thousandsGroupStyle="thousand"
                                      thousandSeparator=","
                                      decimalScale={2}
                                      onValueChange={(val) => {
                                        onChange(val.floatValue)
                                        calculateSalaryForInsurance({
                                          ...getValues(),
                                          [name]: val.floatValue,
                                        })
                                      }}
                                    />
                                  )}
                                />
                                <ErrorMessage errors={errors} name="baseSalary" render={({ message }) => <span className="invalid">{message}</span>} />
                              </div>
                            </div>
                          </Col>
                          <Col size="6">
                            <div className="form-group">
                              <label className="form-label" >
                                Tiền trách nhiệm(đ)
                                <span className="text-danger">*</span>

                              </label>
                              <div className="form-control-wrap">
                                <Controller
                                  control={control}
                                  name="responsibilityAllowance"
                                  rules={{ required: "Vui lòng nhập thông tin" }}
                                  render={({ onChange, value, ref, name }) => (
                                    <NumericFormat
                                      className="form-control"
                                      inputRef={ref}
                                      type="text"
                                      value={value}
                                      thousandsGroupStyle="thousand"
                                      thousandSeparator=","
                                      decimalScale={2}
                                      onValueChange={(val) => {
                                        onChange(val.floatValue)
                                        calculateSalaryForInsurance({
                                          ...getValues(),
                                          [name]: val.floatValue,
                                        })
                                      }}
                                    />
                                  )}
                                />
                                <ErrorMessage errors={errors} name="responsibilityAllowance" render={({ message }) => <span className="invalid">{message}</span>} />

                              </div>
                            </div>
                          </Col>

                          <Col size="6">
                            <div className="form-group">
                              <label className="form-label" >
                                Năm thâm niên
                                <span className="text-danger">*</span>

                              </label>
                              <div className="form-control-wrap">
                                <Controller
                                  control={control}
                                  name="annualYear"
                                  rules={{ required: "Vui lòng nhập thông tin" }}
                                  render={({ onChange, value, ref, name }) => (
                                    <NumericFormat
                                      className="form-control"
                                      inputRef={ref}
                                      type="text"
                                      value={value}
                                      thousandsGroupStyle="thousand"
                                      thousandSeparator=","
                                      decimalScale={0}
                                      onValueChange={(val) => {
                                        const value = Number.parseInt(val.floatValue) || 0
                                        onChange(value)
                                        const template = employeeTemplates.find(e => e.value === unit)?.data;
                                        const index = value - 1;
                                        const salary = template?.annualSalaries?.[index]?.salary || 0
                                        setValue('annualSalary', salary)
                                        calculateSalaryForInsurance({
                                          ...getValues(),
                                          annualSalary: salary,
                                        })
                                      }}
                                    />
                                  )}
                                />
                                <ErrorMessage errors={errors} name="annualYear" render={({ message }) => <span className="invalid">{message}</span>} />

                              </div>
                            </div>
                          </Col>

                          <Col size="6">
                            <div className="form-group">
                              <label className="form-label" >
                                Lần cập nhật thâm niên
                                <span className="text-danger">*</span>

                              </label>
                              <div className="form-control-wrap">
                                <Controller
                                  control={control}
                                  name="lastUpdateAnnualYear"
                                  rules={{ required: "Vui lòng nhập thông tin" }}
                                  render={({ onChange, value, ref, name }) => (
                                    <Input
                                      type="date"
                                      inputRef={ref}
                                      name={name}
                                      onChange={(e) => onChange(e.target.value)}
                                      value={value}
                                    />
                                  )}
                                />
                                <ErrorMessage errors={errors} name="lastUpdateAnnualYear" render={({ message }) => <span className="invalid">{message}</span>} />

                              </div>
                            </div>
                          </Col>
                          <Col size="6">
                            <div className="form-group">
                              <label className="form-label" >
                                Tiền thâm niên(đ)
                                <span className="text-danger">*</span>

                              </label>
                              <div className="form-control-wrap">
                                <Controller
                                  control={control}
                                  name="annualSalary"
                                  rules={{ required: "Vui lòng nhập thông tin" }}
                                  render={({ onChange, value, ref, name }) => (
                                    <NumericFormat
                                      className="form-control"
                                      inputRef={ref}
                                      type="text"
                                      value={value}
                                      thousandsGroupStyle="thousand"
                                      thousandSeparator=","
                                      decimalScale={2}
                                      onValueChange={(val) => {
                                        onChange(val.floatValue)
                                        calculateSalaryForInsurance({
                                          ...getValues(),
                                          [name]: val.floatValue,
                                        })
                                      }}
                                    />
                                  )}
                                />
                                <ErrorMessage errors={errors} name="annualSalary" render={({ message }) => <span className="invalid">{message}</span>} />

                              </div>
                            </div>
                          </Col>

                          <Col size="6" className={isExtendSalaryForInsurance ? '' : 'd-none'}>
                            <div className="form-group">
                              <label className="form-label" >
                                Nhân viên xuất sắc(đ)
                                <span className="text-danger">*</span>

                              </label>
                              <div className="form-control-wrap">
                                <Controller
                                  control={control}
                                  name="bestEmployeeAllowance"
                                  rules={{ required: "Vui lòng nhập thông tin" }}
                                  render={({ onChange, value, ref, name }) => (
                                    <NumericFormat
                                      className="form-control"
                                      inputRef={ref}
                                      type="text"
                                      value={value}
                                      thousandsGroupStyle="thousand"
                                      thousandSeparator=","
                                      decimalScale={2}
                                      onValueChange={(val) => {
                                        onChange(val.floatValue)
                                        calculateSalaryForInsurance({
                                          ...getValues(),
                                          [name]: val.floatValue,
                                        })
                                      }}
                                    />
                                  )}
                                />
                                <ErrorMessage errors={errors} name="bestEmployeeAllowance" render={({ message }) => <span className="invalid">{message}</span>} />

                              </div>
                            </div>
                          </Col>

                          <Col size="6" className={isExtendSalaryForInsurance ? '' : 'd-none'}>
                            <div className="form-group">
                              <label className="form-label" >
                                Công việc/Tay nghề chức vụ(đ)
                                <span className="text-danger">*</span>

                              </label>
                              <div className="form-control-wrap">
                                <Controller
                                  control={control}
                                  name="positionSalary"
                                  rules={{ required: "Vui lòng nhập thông tin" }}
                                  render={({ onChange, value, ref, name }) => (
                                    <NumericFormat
                                      className="form-control"
                                      inputRef={ref}
                                      type="text"
                                      value={value}
                                      thousandsGroupStyle="thousand"
                                      thousandSeparator=","
                                      decimalScale={2}
                                      onValueChange={(val) => {
                                        onChange(val.floatValue)
                                        calculateSalaryForInsurance({
                                          ...getValues(),
                                          [name]: val.floatValue,
                                        })
                                      }}
                                    />
                                  )}
                                />
                                <ErrorMessage errors={errors} name="positionSalary" render={({ message }) => <span className="invalid">{message}</span>} />

                              </div>
                            </div>
                          </Col>
                          <Col size="6" className={isExtendSalaryForInsurance ? '' : 'd-none'}>
                            <div className="form-group">
                              <label className="form-label" >
                                Nặng nhọc/độc hại(đ)
                                <span className="text-danger">*</span>

                              </label>
                              <div className="form-control-wrap">
                                <Controller
                                  control={control}
                                  name="toxicAllowance"
                                  rules={{ required: "Vui lòng nhập thông tin" }}
                                  render={({ onChange, value, ref, name }) => (
                                    <NumericFormat
                                      className="form-control"
                                      inputRef={ref}
                                      type="text"
                                      value={value}
                                      thousandsGroupStyle="thousand"
                                      thousandSeparator=","
                                      decimalScale={2}
                                      onValueChange={(val) => {
                                        onChange(val.floatValue)
                                        calculateSalaryForInsurance({
                                          ...getValues(),
                                          [name]: val.floatValue,
                                        })
                                      }}
                                    />
                                  )}
                                />
                                <ErrorMessage errors={errors} name="toxicAllowance" render={({ message }) => <span className="invalid">{message}</span>} />

                              </div>
                            </div>
                          </Col>

                          <Col size="6">
                            <div className="form-group">
                              <label className="form-label" >
                                Lương cơ bản tính lương(đ)
                                <span className="text-danger">*</span>
                              </label>
                              <div className="form-control-wrap">
                                <Controller
                                  control={control}
                                  name="salaryForCalculator"
                                  render={({ onChange, value, ref }) => (
                                    <NumericFormat
                                      className="form-control"
                                      inputRef={ref}
                                      type="text"
                                      value={value}
                                      thousandsGroupStyle="thousand"
                                      thousandSeparator=","
                                      decimalScale={2}
                                      onValueChange={(val) => onChange(val.floatValue)}
                                    />
                                  )}
                                />
                              </div>
                            </div>
                            <ErrorMessage errors={errors} name="salaryForCalculator" render={({ message }) => <span className="invalid">{message}</span>} />
                          </Col>
                          <Col size="6">
                            <div className="form-group">
                              <label className="form-label" >
                                Lương tính BH(đ)
                                <span className="text-danger">*</span>
                              </label>
                              <div className="form-control-wrap">
                                <Controller
                                  control={control}
                                  name="salaryForInsurance"
                                  render={({ onChange, value, ref }) => (
                                    <NumericFormat
                                      className="form-control"
                                      inputRef={ref}
                                      type="text"
                                      value={value}
                                      thousandsGroupStyle="thousand"
                                      thousandSeparator=","
                                      decimalScale={2}
                                      onValueChange={(val) => onChange(val.floatValue)}
                                    />
                                  )}
                                />
                              </div>
                            </div>
                            <ErrorMessage errors={errors} name="salaryForInsurance" render={({ message }) => <span className="invalid">{message}</span>} />

                          </Col>
                        </Row>
                      </div>
                      <div className="mt-4">
                        <Row className="g-2">
                          <Col size="12">
                            <h4>Thuế TNCN</h4>
                          </Col>

                          <Col size="6">
                            <div className="form-group">
                              <label className="form-label" >
                                Số người phụ thuộc
                                <span className="text-danger">*</span>
                              </label>
                              <div className="form-control-wrap">
                                <Controller
                                  control={control}
                                  name="dependents"
                                  render={({ onChange, value, ref }) => (
                                    <NumericFormat
                                      className="form-control"
                                      inputRef={ref}
                                      type="text"
                                      value={value}
                                      thousandsGroupStyle="thousand"
                                      thousandSeparator=","
                                      decimalScale={0}
                                      onValueChange={(val) => onChange(val.floatValue || 0)}
                                    />
                                  )}
                                />
                              </div>
                            </div>
                            <ErrorMessage errors={errors} name="dependents" render={({ message }) => <span className="invalid">{message}</span>} />

                          </Col>

                          <Col size="6">
                            <div className="form-group">
                              <label className="form-label" >
                                Tiền BHXH(đ)
                                <span className="text-danger">*</span>
                              </label>
                              <div className="form-control-wrap">
                                <Controller
                                  control={control}
                                  name="pit"
                                  render={({ onChange, value, ref }) => (
                                    <NumericFormat
                                      className="form-control"
                                      inputRef={ref}
                                      type="text"
                                      value={value}
                                      thousandsGroupStyle="thousand"
                                      thousandSeparator=","
                                      decimalScale={0}
                                      onValueChange={(val) => onChange(val.floatValue || 0)}
                                    />
                                  )}
                                />
                              </div>
                            </div>
                            <ErrorMessage errors={errors} name="pit" render={({ message }) => <span className="invalid">{message}</span>} />

                          </Col>
                        </Row>
                      </div>
                      <div className="mt-4">
                        <Row className="g-2">
                          <Col size="12">
                            <h4>Công việc</h4>
                          </Col>
                          <Col size="6">
                            <div className="form-group">
                              <label className="form-label" >
                                Trợ cấp xăng xe(đ)
                              </label>
                              <div className="form-control-wrap">
                                <Controller
                                  control={control}
                                  name="travelAllowance"
                                  render={({ onChange, value, ref }) => (
                                    <NumericFormat
                                      className="form-control"
                                      inputRef={ref}
                                      type="text"
                                      value={value}
                                      thousandsGroupStyle="thousand"
                                      thousandSeparator=","
                                      decimalScale={2}
                                      onValueChange={(val) => onChange(val.floatValue)}
                                    />
                                  )}
                                />
                              </div>
                            </div>
                          </Col>

                          <Col size="6">
                            <div className="form-group">
                              <label className="form-label" >
                                Trợ cấp atld/vệ sinh(đ)
                              </label>
                              <div className="form-control-wrap">
                                <Controller
                                  control={control}
                                  name="laborSafetyAllowance"
                                  render={({ onChange, value, ref }) => (
                                    <NumericFormat
                                      className="form-control"
                                      inputRef={ref}
                                      type="text"
                                      value={value}
                                      thousandsGroupStyle="thousand"
                                      thousandSeparator=","
                                      decimalScale={2}
                                      onValueChange={(val) => onChange(val.floatValue)}
                                    />
                                  )}
                                />
                              </div>
                            </div>
                          </Col>

                          <Col size="6">
                            <div className="form-group">
                              <label className="form-label" >
                                Trợ cấp điện thoại(đ)
                              </label>
                              <div className="form-control-wrap">
                                <Controller
                                  control={control}
                                  name="telephoneAllowance"
                                  render={({ onChange, value, ref }) => (
                                    <NumericFormat
                                      className="form-control"
                                      inputRef={ref}
                                      type="text"
                                      value={value}
                                      thousandsGroupStyle="thousand"
                                      thousandSeparator=","
                                      decimalScale={2}
                                      onValueChange={(val) => onChange(val.floatValue)}
                                    />
                                  )}
                                />
                              </div>
                            </div>
                          </Col>
                          <Col size="6">
                            <div className="form-group">
                              <label className="form-label" >
                                Trợ cấp nhà ở(đ)
                              </label>
                              <div className="form-control-wrap">
                                <Controller
                                  control={control}
                                  name="housingSubsidy"
                                  render={({ onChange, value, ref }) => (
                                    <NumericFormat
                                      className="form-control"
                                      inputRef={ref}
                                      type="text"
                                      value={value}
                                      thousandsGroupStyle="thousand"
                                      thousandSeparator=","
                                      decimalScale={2}
                                      onValueChange={(val) => onChange(val.floatValue)}
                                    />
                                  )}
                                />
                              </div>
                            </div>
                          </Col>
                          <Col size="6">
                            <div className="form-group">
                              <label className="form-label" >
                                Lương năng suất(đ)
                              </label>
                              <div className="form-control-wrap">
                                <Controller
                                  control={control}
                                  name="productivitySalary"
                                  render={({ onChange, value, ref }) => (
                                    <NumericFormat
                                      className="form-control"
                                      inputRef={ref}
                                      type="text"
                                      value={value}
                                      thousandsGroupStyle="thousand"
                                      thousandSeparator=","
                                      decimalScale={2}
                                      onValueChange={(val) => onChange(val.floatValue)}
                                    />
                                  )}
                                />
                              </div>
                            </div>
                          </Col>
                          <Col size="6">
                            <div className="form-group">
                              <label className="form-label" >
                                Thưởng chuyên cần(đ)
                              </label>
                              <div className="form-control-wrap">
                                <Controller
                                  control={control}
                                  name="attendanceAllowance"
                                  render={({ onChange, value, ref }) => (
                                    <NumericFormat
                                      className="form-control"
                                      inputRef={ref}
                                      type="text"
                                      value={value}
                                      thousandsGroupStyle="thousand"
                                      thousandSeparator=","
                                      decimalScale={2}
                                      onValueChange={(val) => onChange(val.floatValue)}
                                    />
                                  )}
                                />
                              </div>
                            </div>
                          </Col>

                          <Col size="6">
                            <div className="form-group">
                              <label className="form-label" >
                                Tính bảo hiểm từ ngày:
                              </label>
                              <div className="form-control-wrap">
                                <input className="form-control" type="date" name="insuranceTaxStartAt" ref={register()} />
                              </div>
                            </div>
                          </Col>

                          <Col md="6">
                            <div className="form-group">
                              <label className="form-label" htmlFor="customer">
                                Trạng thái
                                <span className="text-danger">*</span>
                              </label>
                              <div className="form-control-wrap">
                                <Controller
                                  control={control}
                                  name="status"
                                  rules={{
                                    required: "Vui lòng nhập thông tin",
                                  }}
                                  render={({ onChange, value, name, ref }) => (
                                    <ReactSelect
                                      classNamePrefix="form-control"
                                      inputRef={ref}
                                      name={name}
                                      options={EMPLOYEE_STATUS_OPTIONS}
                                      value={EMPLOYEE_STATUS_OPTIONS.find((c) => c.value === value)}
                                      onChange={(val) => onChange(val.value)}
                                    />
                                  )}
                                />
                                <ErrorMessage errors={errors} name="status" render={({ message }) => <span className="invalid">{message}</span>} />
                              </div>
                            </div>
                          </Col>
                          <Col size="6">
                            <div className="form-group">
                              <label className="form-label" >
                                Ngày công tối thiểu để hưởng phép
                              </label>
                              <div className="form-control-wrap">
                                <Controller
                                  control={control}
                                  name="workingDayToReceivedFullAllowance"
                                  render={({ onChange, value, ref }) => (
                                    <NumericFormat
                                      className="form-control"
                                      inputRef={ref}
                                      type="text"
                                      value={value}
                                      thousandsGroupStyle="thousand"
                                      thousandSeparator=","
                                      decimalScale={0}
                                      onValueChange={(val) => onChange(val.floatValue ?? null)}
                                    />
                                  )}
                                />
                              </div>
                            </div>
                          </Col>
                          <Col size="6">
                            <div className="form-group">
                              <label className="form-label" >
                                Trợ cấp ăn trưa(T.Xế: /tháng, Còn lại: /ngày)(đ)
                              </label>
                              <div className="form-control-wrap">
                                <Controller
                                  control={control}
                                  name="foodAllowancePerShift"
                                  render={({ onChange, value, ref }) => (
                                    <NumericFormat
                                      className="form-control"
                                      inputRef={ref}
                                      type="text"
                                      value={value}
                                      thousandsGroupStyle="thousand"
                                      thousandSeparator=","
                                      decimalScale={2}
                                      onValueChange={(val) => onChange(val.floatValue ?? null)}
                                    />
                                  )}
                                />
                              </div>
                            </div>
                          </Col>

                          <Col md="3">
                            <div className="form-group">
                              <label className="form-label" >
                                Hưởng trợ cấp ăn
                                <span className="text-danger">*</span>
                              </label>
                              <div className="form-control-wrap">
                                <Controller
                                  control={control}
                                  name="allowFoodAllowance"
                                  render={({ onChange, value, name }) => <input type="checkbox" checked={!!value} name={name} onChange={(e) => onChange(e.target.checked)} />}
                                />
                                <ErrorMessage errors={errors} name="allowFoodAllowance" render={({ message }) => <span className="invalid">{message}</span>} />
                              </div>
                            </div>
                          </Col>
                          <Col md="3">
                            <div className="form-group">
                              <label className="form-label" >
                                Cho xuống hàng
                                <span className="text-danger">*</span>
                              </label>
                              <div className="form-control-wrap">
                                <Controller
                                  control={control}
                                  name="allowPieceWage"
                                  render={({ onChange, value, name }) => <input type="checkbox" checked={!!value} name={name} onChange={(e) => onChange(e.target.checked)} />}
                                />
                                <ErrorMessage errors={errors} name="allowPieceWage" render={({ message }) => <span className="invalid">{message}</span>} />
                              </div>
                            </div>
                          </Col>
                          <Col md="3">
                            <div className="form-group">
                              <label className="form-label" >
                                Cho lái xe cẩu
                                <span className="text-danger">*</span>
                              </label>
                              <div className="form-control-wrap">
                                <Controller
                                  control={control}
                                  name="allowCrane"
                                  render={({ onChange, value, name }) => <input type="checkbox" checked={!!value} name={name} onChange={(e) => onChange(e.target.checked)} />}
                                />
                                <ErrorMessage errors={errors} name="allowCrane" render={({ message }) => <span className="invalid">{message}</span>} />
                              </div>
                            </div>
                          </Col>
                          <Col md="3">
                            <div className="form-group">
                              <label className="form-label" >
                                Là nấu dầu
                                <span className="text-danger">*</span>
                              </label>
                              <div className="form-control-wrap">
                                <Controller
                                  control={control}
                                  name="allowOilRefining"
                                  render={({ onChange, value, name }) => <input type="checkbox" checked={!!value} name={name} onChange={(e) => onChange(e.target.checked)} />}
                                />
                                <ErrorMessage errors={errors} name="allowOilRefining" render={({ message }) => <span className="invalid">{message}</span>} />
                              </div>
                            </div>
                          </Col>
                          <Col md={3}>
                            <div className="form-group">
                              <label className="form-label mr-2" htmlFor="customer">
                                Còn làm việc
                              </label>
                              <div className="form-control-wrap">

                                <Controller
                                  control={control}
                                  name="active"
                                  render={({ onChange, value, name, ref }) => <input type="checkbox" checked={!!value} name={name} onChange={(e) => onChange(e.target.checked)} />}
                                />
                              </div>
                            </div>
                          </Col>
                          <Col md={3}>
                            <div className="form-group">
                              <label className="form-label mr-2" htmlFor="customer">
                                Tính lương trên hệ thống này
                              </label>
                              <div className="form-control-wrap">

                                <Controller
                                  control={control}
                                  name="allowSalary"
                                  render={({ onChange, value, name, ref }) => <input type="checkbox" checked={!!value} name={name} onChange={(e) => onChange(e.target.checked)} />}
                                />
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </div>

                      <Row className="g-3 ">
                        <Col size="6 " className="mt-3">
                          <Button color="primary" type="submit">
                            <span>Lưu</span>
                          </Button>
                        </Col>
                      </Row>
                    </form>
                  </FormProvider>
                </div>
              </div>
            </div>
          </div>
        </Block>
      </Content>
    </React.Fragment>
  );
};

export default AddEmployee;
